import React from 'react';
import { Dengue2025 } from '../views';

const DesignCompanyPage = () => {
  return <Dengue2025/>;
};

export default DesignCompanyPage;
